import { ChevronDown } from "lucide-react";

const ScrollIndicator = () => {
  return (
    <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-fade-in" style={{ animationDelay: "1.2s" }}>
      <span className="text-xs text-muted-foreground uppercase tracking-wider">
        Scroll
      </span>
      <div className="animate-bounce">
        <ChevronDown className="text-muted-foreground" size={20} />
      </div>
    </div>
  );
};

export default ScrollIndicator;
